export default "__VITE_ASSET__D5zfovaX__"